import { render } from "./extensionCodeStatistics.vue?vue&type=template&id=1f920812&scoped=true"
import script from "./extensionCodeStatistics.vue?vue&type=script&lang=js"
export * from "./extensionCodeStatistics.vue?vue&type=script&lang=js"

import "./extensionCodeStatistics.vue?vue&type=style&index=0&id=1f920812&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f920812"]])

export default __exports__